function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilityElevatorFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12a2 2 0 00-2 2v14a2 2 0 002 2h20a2 2 0 002-2V14a2 2 0 00-2-2H6zm1 2a1 1 0 00-1 1v12a1 1 0 001 1h18a1 1 0 001-1V15a1 1 0 00-1-1H7z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 22l-1.2 1.6a1 1 0 01-1.6-1.2l1.4-1.866a3 3 0 014.8 0l1.4 1.866a1 1 0 01-1.6 1.2L12 22v4a1 1 0 11-2 0v-4zM20 22l-1.2 1.6a1 1 0 01-1.6-1.2l1.4-1.866a3 3 0 014.8 0l1.4 1.866a1 1 0 01-1.6 1.2L22 22v4a1 1 0 11-2 0v-4zM14.707 5.293L11 1.586 7.293 5.293a1 1 0 001.414 1.414L10 5.414V10h2V5.414l1.293 1.293a1 1 0 101.414-1.414zM22 2h-2v4.586l-1.293-1.293a1 1 0 10-1.414 1.414L21 10.414l3.707-3.707a1 1 0 00-1.414-1.414L22 6.586V2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17a2 2 0 11-4 0 2 2 0 014 0zM23 17a2 2 0 11-4 0 2 2 0 014 0z",
    fill: props.color
  }));
}

export default SvgIconFacilityElevatorFilled;